import React, { useCallback, useEffect, useState } from 'react'
import SwiperCore, { Swiper as ISwiper, Navigation } from 'swiper'
import { Swiper, SwiperSlide } from 'swiper/react'
import 'swiper/css'
import 'swiper/css/navigation'
import { BaseAsset } from 'types/Response'
import ImageSlide from './slides/ImageSlide'
import LoaderSlide from './slides/LoaderSlide'
import c from './ImageSlider.module.scss'

interface ImageSliderProps {
  assets: BaseAsset[]
  onCurrentAssetIndexChange: (newCurrentAssetIndex: number) => void
}

function ImageSlider({ assets, onCurrentAssetIndexChange }: ImageSliderProps) {
  const [swiperRef, setSwiperRef] = useState<SwiperCore>()

  const handleIndexChange = useCallback(
    (s: ISwiper) => {
      onCurrentAssetIndexChange(s.activeIndex)
    },
    [onCurrentAssetIndexChange],
  )

  useEffect(() => {
    const firstProcessedAssetIndex = assets.findIndex((a) => a.url)
    if (firstProcessedAssetIndex > 0) {
      swiperRef?.slideTo(firstProcessedAssetIndex, 0)
    }
  }, [swiperRef])

  return (
    <div className={c.container}>
      <Swiper
        className={c.slider}
        modules={[Navigation]}
        navigation
        onSwiper={setSwiperRef}
        onActiveIndexChange={handleIndexChange}
      >
        {assets.map(({ id, url }, index) => (
          <SwiperSlide className={c.slide} key={id}>
            {url ? (
              <ImageSlide imageUrl={url} />
            ) : (
              <LoaderSlide index={index} />
            )}
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  )
}

export default ImageSlider
